import React, { useState } from 'react'
import {
  Box, Container, Paper, Typography, TextField, Button, Stack, Alert,
} from '@mui/material'
import { router } from '@inertiajs/react'

const ROLE_LABELS = {
  admin: 'Administrator',
  manager: 'Manager',
  accountant: 'Buchhalter',
  readonly: 'Nur Lesen',
}

export default function AcceptInvitation({ invitation, existing_user = false, errors = {} }) {
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [password, setPassword] = useState('')
  const [passwordConfirmation, setPasswordConfirmation] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    setSubmitting(true)
    const payload = existing_user
      ? {}
      : { first_name: firstName, last_name: lastName, password, password_confirmation: passwordConfirmation }
    router.patch(`/invitations/${invitation.token}`, { user: payload }, {
      onFinish: () => setSubmitting(false),
    })
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 6 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom>Einladung annehmen</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Sie wurden von <strong>{invitation.invited_by}</strong> als{' '}
          <strong>{ROLE_LABELS[invitation.role] || invitation.role}</strong> zu{' '}
          <strong>{invitation.tenant_name}</strong> eingeladen.
        </Typography>

        <Box component="form" onSubmit={handleSubmit}>
          <Stack spacing={2}>
            <TextField label="E-Mail" value={invitation.email} disabled fullWidth />

            {existing_user ? (
              <Alert severity="info">
                Ein Benutzerkonto mit dieser E-Mail-Adresse existiert bereits. Klicken Sie
                auf "Einladung annehmen", um den Zugang zu diesem Mandanten zu erhalten.
                Sie können sich anschließend mit Ihrem bestehenden Passwort anmelden.
              </Alert>
            ) : (
              <>
                <TextField
                  label="Vorname"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  required
                  fullWidth
                  error={Boolean(errors.first_name)}
                  helperText={errors.first_name?.[0]}
                  slotProps={{ htmlInput: { 'data-testid': 'accept-first-name' } }}
                />
                <TextField
                  label="Nachname"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  required
                  fullWidth
                  error={Boolean(errors.last_name)}
                  helperText={errors.last_name?.[0]}
                  slotProps={{ htmlInput: { 'data-testid': 'accept-last-name' } }}
                />
                <TextField
                  label="Passwort"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  fullWidth
                  error={Boolean(errors.password)}
                  helperText={errors.password?.[0]}
                  slotProps={{ htmlInput: { 'data-testid': 'accept-password' } }}
                />
                <TextField
                  label="Passwort bestätigen"
                  type="password"
                  value={passwordConfirmation}
                  onChange={(e) => setPasswordConfirmation(e.target.value)}
                  required
                  fullWidth
                  error={Boolean(errors.password_confirmation)}
                  helperText={errors.password_confirmation?.[0]}
                  slotProps={{ htmlInput: { 'data-testid': 'accept-password-confirmation' } }}
                />
              </>
            )}

            <Button
              type="submit"
              variant="contained"
              disabled={submitting}
              data-testid="accept-submit-btn"
            >
              Einladung annehmen
            </Button>
          </Stack>
        </Box>
      </Paper>
    </Container>
  )
}
